// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

const createGetContent = (pathName: string) =>
  wrapWithNetworkError(function getContent(token) {
    const fetchUrl = getEndpointUrl(`/moderate/${pathName}`);
    const fetchOptions = {
      headers: {
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => {
        if (response.status === 204) {
          return [];
        }

        return response.json();
      })
      .then((json: GetContentResponse) => (Array.isArray(json) ? json : [json]))
      .catch(error => {
        console.error('Error while calling getContent: ', error);
      });
  });

export default createGetContent;



// WEBPACK FOOTER //
// ./src/api/content/createGetContent.js